import PropTypes from 'prop-types';
import topicAttributeShape from './topicAttributeShape';

const topicShape = {
  id: PropTypes.number.isRequired,
  attributes: PropTypes.shape(topicAttributeShape).isRequired,
};

export default topicShape;
